<template>
    <div ref="tooltip">
        <div class="cell-tooltip" v-if="type && data" @click="onClick" @mouseover="positionTooltip($event)">
            {{ tooltipValue }}
            <span class="tooltiptext" v-html="tooltipText" v-if="hasTooltip"></span>
        </div>
    </div>
</template>

<script>

    import { EventBus } from '@/utils/EventBus.js';

    export default {
        name: 'tooltip',
        props: ['data', 'index'],
        data() {
            return {
                type: null,
                hasTooltip: null
            }
        },
        methods: {
            onClick() {
                EventBus.$emit('tooltipClicked', {
                    id: this.tooltipId,
                    type: this.type,
                    name: this.data.feed_name
                });
            },
            positionTooltip(event) {
                if(this.hasTooltip)
                {
                    event.target.children[0].style.left = (event.target.getBoundingClientRect().left - event.target.children[0].getBoundingClientRect().width - 5) + "px";
                    event.target.children[0].style.top = (event.target.getBoundingClientRect().top) + "px";
                }
            }
        },
        computed: {
            tooltipId() {
                var val = this.data[this.type];
                return val.id
            },
            tooltipValue() {
                var val = this.data[this.type];
                return val.val
            },
            tooltipText() {
                var val = this.data[this.type];
                return val.tooltip.join("<br/>")
            }
        },
        mounted() {
            var classStr = this.$refs.tooltip.parentElement.parentElement.getAttribute("class");
            var lastClass = classStr.split(" ");
            lastClass = lastClass[lastClass.length - 1];

            this.type = lastClass;
            this.hasTooltip = this.data[this.type].tooltip.length;
        }
    }

</script>

<style scoped>
    .cell-tooltip {
        position: relative;
        display: inline-block;
        cursor: pointer;
    }

    .cell-tooltip .tooltiptext {
        visibility: hidden;
        position: fixed;
        width: auto;
        background-color: rgba(0, 0, 0, 0.3);
        color: #fff;
        text-align: center;
        padding: 5px 0;
        opacity: 0;
        transition: opacity 0.3s;
        border: 2px solid #000;
    }

    .cell-tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
        z-index: 10;
    }
</style>



// WEBPACK FOOTER //
// src/components/tooltip/Tooltip.vue